import { render, staticRenderFns } from "./StartCampaignModal.vue?vue&type=template&id=19c98e19&scoped=true&"
import script from "./StartCampaignModal.vue?vue&type=script&lang=js&"
export * from "./StartCampaignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c98e19",
  null
  
)

export default component.exports